<template>
    <el-skeleton style="width: 80%; height: 20px;" animated>
        <template slot="template">
            <el-skeleton-item variant="rect" style="width: 80%; height: 20px;" />
        </template>
    </el-skeleton>
</template>

<script>
export default {

}
</script>

<style>

</style>